// src/lib/advisorConnect.js
//
// Shared call to the advisor-connect edge function. Previously this fetch
// lived inline inside AdvisorConnectForm.js; it moved here when that
// component stopped owning submission (see AdvisorConnectForm.js header).
// ResultCTA.js is the only caller today, but this keeps the request shape
// and error handling in one place rather than inlined in a UI component.
//
// sessionId (new): a draft calculator session has no public_token yet
// (see the draft/publish lifecycle in calculate-irpf/index.ts) — passing
// sessionId lets advisor-connect look the row up by its internal id
// instead. Triage callers and already-published calculator sessions can
// leave this undefined; publicToken alone still works for them.

// marketing_consent: only sent when contact.marketingConsent is an actual
// boolean, not coerced with `=== true`. AdvisorConnectForm.js sends
// `undefined` when its checkbox was hidden (the person already answered
// this earlier in the same session) — coercing that to `false` here would
// tell advisor-connect a fresh answer was given when none was, which is
// exactly the bug this fixed: a real prior opt-in silently overwritten by
// an unasked "no." Same conditional-omission pattern claimSession.js
// already uses for consentPartnerShare.

export async function submitAdvisorConnect({ product, publicToken, sessionId, contact }) {
  const res = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/advisor-connect`,
    {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product,
        public_token:      publicToken,
        session_id:        sessionId,
        contact_name:      contact.name,
        contact_email:     contact.email,
        contact_phone:     contact.phone ?? null,
        ...(typeof contact.marketingConsent === 'boolean' ? { marketing_consent: contact.marketingConsent } : {}),
      }),
    }
  )
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || 'Something went wrong. Please try again.')
  return data
}